import { FeatureFlagSwitch } from "../FeatureFlagSwitch/FeatureFlagSwitch";
import { GranularGroupFilters } from "./GranularGroupFilters";
import { GroupTypeFilter } from "./GroupTypeFilter";
import { Flags } from "../../../feature-flags/flags";
import { IGroupFilters } from "../../../types/GroupFilters";

interface IGroupFiltersProps {
    className?: string;
    hideProductGroupFilter?: boolean;
    onChange: (filters: IGroupFilters) => void;
    selectedFilters?: IGroupFilters;
}

export const GroupFilters = ({
    className = "",
    hideProductGroupFilter = false,
    onChange,
    selectedFilters = { groupTypes: [] }
}: IGroupFiltersProps) => {
    const updateGroupTypeFilter = (groupTypes: string[]) => {
        onChange({ ...selectedFilters, groupTypes });
    };

    const updateFilter = (updates: { type: string; value: any }[]) => {
        const updated: IGroupFilters = { ...selectedFilters };
        updates.forEach(({ type, value }) => {
            updated[type as keyof IGroupFilters] = value;
        });
        onChange({ ...updated });
    };

    return (
        <FeatureFlagSwitch
            featureFlag={Flags.ENABLE_GRANULAR_GROUP_FILTERS}
            onElement={
                <GranularGroupFilters
                    selectedFilters={selectedFilters}
                    className={className}
                    onFiltersChange={updateFilter}
                />
            }
            offElement={
                <GroupTypeFilter
                    onChange={updateGroupTypeFilter}
                    hideProductGroupFilter={hideProductGroupFilter}
                    selectedGroupTypes={selectedFilters?.groupTypes}
                />
            }
        />
    );
};

GroupFilters.displayName = "GroupFilters";
